import ModeContext from '../../context/ModeContext'

import {LINK} from '../Videos/styledComponents'

import {
  GamingContainer,
  GamingImg,
  GamingTitle,
  GamingPara,
} from './styledComponents'

const GamingVideo = props => {
  const {video} = props
  const {id, thumbnailUrl, title, viewCount} = video

  return (
    <ModeContext.Consumer>
      {value => {
        const {isDarkMode} = value
        const color = isDarkMode ? 'white' : '#212121'
        const paraColor = isDarkMode ? '#909090' : '#606060'

        return (
          <LINK to={`/videos/${id}`}>
            <GamingContainer>
              <GamingImg src={thumbnailUrl} alt="video thumbnail" />
              <GamingTitle color={color}>{title}</GamingTitle>
              <GamingPara paraColor={paraColor}>
                {viewCount} Watching Worldwide
              </GamingPara>
            </GamingContainer>
          </LINK>
        )
      }}
    </ModeContext.Consumer>
  )
}

export default GamingVideo
